
import { API_ROOT, sendRequest } from "../../supplementary_components/requests";
import { BsThreeDots } from "react-icons/bs";
import { IoMdSync } from "react-icons/io";
import { addNotification, addPopup } from "../../supplementary_components/store";
import { Form } from "../../general_components/forms/Form";
import { swapSVGWhileProcessing } from "../../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection";
import { MdHistory } from "react-icons/md";
import { openActivitiesPopup } from "../../general_components/activitiesPopup/activitiesPopup";
import activitiesStyles from "../../general_components/activitiesPopup/activitiesPopup.module.scss";
import { FuelCardListStatusCell } from "./fuelCardStatusToggle/FuelCardListStatusCell";
import { FuelCardListToggleProvider } from "./fuelCardStatusToggle/fuelCardListToggleContext";

const FUEL_CARD_ACTIVITIES_POPUP_FLAG = 'fuelCardActivities';

function openFuelCardActivitiesPopup(fuelCard) {
    openActivitiesPopup({
        targetType: 'FUEL_CARD',
        objectId: fuelCard.id,
        titleLabel: fuelCard.cardNumber ?? '',
        popupKind: FUEL_CARD_ACTIVITIES_POPUP_FLAG,
    });
}
export const FUEL_CARD_LISTING_CONF = {
    getRequestLink: API_ROOT + "fuelcards",
    columnProportions: "20% 20% 10% 20% 12% 1fr 3rem",
    dataTitle: "Fuel Card",
    dataTitlePlural: "Fuel Cards",
    category: 'fuel-cards',
    editAccessLevel: { key: 'FUEL_CARDS', level: 'MANAGE' },
    listWrapper: ({ children }) => <FuelCardListToggleProvider>{children}</FuelCardListToggleProvider>,
    categorizedList: {
        defaultOptionIndex: 0,
        options: [
            { label: "EFS Fuel Cards" },
        ],
    },
    specialActions: [
        {
            requiredPermission: { key: 'FUEL_CARDS', level: 'MANAGE' },
            buttonLabel: '',
            icon: <BsThreeDots />,
            notGreenButton: true,
            menuItems: (requestReload, selectedCategory) =>
                selectedCategory?.label
                    ? [{
                        label: (
                            <>
                                Sync All Cards <IoMdSync />
                            </>
                        ),
                        closeOnClick: false,
                        onClick: (e, _requestReload, _selectedCategory, { closeMenu }) => {
                            if (selectedCategory.label !== "EFS Fuel Cards") return;
                            const svgTag = e.currentTarget.querySelector('svg');
                            if (!svgTag) return;
                            const syncAllEfsCards = () =>
                                new Promise((resolve) => {
                                    sendRequest(
                                        'POST',
                                        API_ROOT + 'fuelcards/sync-all-efs-cards',
                                        null,
                                        () => {
                                            requestReload();
                                            addNotification({ message: 'Fuel cards synced from EFS', type: 'success' });
                                            closeMenu();
                                            resolve();
                                        },
                                        (err) => {
                                            addNotification({
                                                message: err.customError ? err.customError : 'Something Went Wrong',
                                                type: 'alert',
                                            });
                                            closeMenu();
                                            resolve();
                                        }
                                    );
                                });
                            swapSVGWhileProcessing(syncAllEfsCards, svgTag, null, null, '0.15rem', 'var(--gray)');
                        },
                    }]
                    : [],
        },
    ],
    filtration: {
        filtrationLinkRoot: "fuelcards/filtration",
        categoryLabel: "EFS Fuel Cards",
        searchByFieldNames: [
            {
                valueLocation: "cardNumber",
                categoryLbl: "By Card Number",
                searchKey: "byCardNumber",
            },
            {
                valueLocation: "cardNumber",
                filtrationLbl: "card:",
                searchKey: "byCardNumber",
                hint: "Card Number",
            },
            {
                valueLocation: "currentTruck.truckNumber",
                filtrationLbl: "truck:",
                searchKey: "byTruckNumber",
                hint: "Truck Number",
            },
        ],
    },
    columns :[
        {
            label: "Card Number",
            columnName: "cardNumber",
            valueGenerator: (data)=>{
                return {cardNumber: data.cardNumber, blocked: data.blocked};
            },
            valueInterpreter: (value)=>{
                return value.cardNumber;
            },
            conditionalFormatting: (value) => {
                if (!value?.blocked) return null;
                return `
                    display: inline-flex;
                    align-items: center;
                    max-width: 100%;
                    min-width: 0;
                    overflow: hidden;
                    
                    &::after {
                        content: 'Blocked';
                        flex-shrink: 0;
                        margin-left: 0.35rem;
                        font-size: 0.62rem;
                        font-weight: 600;
                        line-height: 1;
                        letter-spacing: 0.03em;
                        text-transform: uppercase;
                        color: var(--alert-color);
                        background-color: color-mix(in srgb, var(--alert-color) 14%, transparent);
                        border: thin solid color-mix(in srgb, var(--alert-color) 40%, transparent);
                        border-radius: 0.25rem;
                        padding: 0.14rem 0.32rem;
                        pointer-events: none;
                    }
                `;
            },

        },
        {
            label: "Current Truck",
            columnName: "currentTruckLabel",
            sortable: true,
            clickable: false,
            
            // valueInterpreter: (value)=>{
            //     return value && value['truckNumber'] ? value['truckNumber'] : '-';
            // },
        },
        {
            label: "Driver Id",
            columnName: "pin",
            alignment:"center",
        },
        
        {
            label: "Driver Name",
            columnName: "driverName",
            alignment:"center",
        },
        {
            label: "Status",
            columnName: "status",
            alignment:"center",
            customComponent: (fuelCard, _selectedCategory, _requestReload, { setData, setFilteredData } = {}) => (
                <FuelCardListStatusCell
                    key={`fuel-card-status-${fuelCard.id}`}
                    fuelCard={fuelCard}
                    setData={setData}
                    setFilteredData={setFilteredData}
                />
            ),
        },
        {
            label: "Latest Actions",
            columnName: "lastestActions",
            alignment:"center",
            customComponent: (data) => {
                return (
                    <div
                        key={"fuel-card-id" + data.id}
                        className={activitiesStyles.latestActionsContainer}
                        onClick={(e) => {
                            e.stopPropagation();
                            openFuelCardActivitiesPopup(data);
                        }}
                    >
                        <MdHistory />
                    </div>
                );
            }
        },
        {
            actionButtons:true,
            syncInsteadRemove: true,
            notEditableIfValueIs : (val)=>{
                return false;
            },
            onEditAction: (fuelCard, postSuccessAction, setData, setFilteredData)=>{
                const fuelCardEditConf = FUEL_CARD_EDIT_CONF(fuelCard);
                fuelCardEditConf.columns = fuelCardEditConf.columns.filter(column => column !== null);
                addPopup(
                    {
                        content:Form, 
                        popupData:{configuration: fuelCardEditConf}, 
                        postSuccessAction: (payload)=>{
                            if(Array.isArray(payload)){
                                const updatedCards = {};
                                payload.forEach(item => {
                                    updatedCards[item.id] = item;
                                });
                                setData(prev => prev.map(item => updatedCards[item.id] ? updatedCards[item.id] : item));
                                setFilteredData(prev => {
                                    if(!prev)return prev;
                                    prev.dataset = prev.dataset.map(item => updatedCards[item.id] ? updatedCards[item.id] : item);
                                    return prev;
                                });
                            }else{
                                setData(prev => prev.map(item => item.id === fuelCard.id ? payload : item));
                                setFilteredData();

                            }
                        }, 
                        EZCloseAllowed:false
                    }
                )
            },
            onSyncAction: (fuelCard, postSuccessAction, setData, setFilteredData) =>
                new Promise((resolve) => {
                    sendRequest('POST', API_ROOT + `fuelcards/${fuelCard.id}/sync`, null, (payload) => {
                        setData(prev => prev.map(item => item.id === payload.id ? payload : item));
                        setFilteredData(prev => {
                            if (!prev) return prev;
                            return {
                                ...prev,
                                dataset: prev.dataset.map(item => item.id === payload.id ? payload : item),
                            };
                        });
                        addNotification({ message: 'Fuel card synced from EFS', type: 'success' });
                        resolve();
                    }, (e) => {
                        addNotification({
                            message: e.customError ? e.customError : 'Sync failed',
                            type: 'alert',
                        });
                        resolve();
                    });
                }),
            onRemoveAction: (fuelCard, postSuccessAction)=>{
            }
        }
    ]
}


export const FUEL_CARD_EDIT_CONF = (fuelCard) => {
    return {
        formAccessLevel:{ key: 'FUEL_CARDS', level: 'MANAGE' },
        formTitle: "Edit Fuel Card",
        name: 'editFuelCardForm',
        addLink: API_ROOT+'fuelcards/edit',
        successMessage:'Fuel card was edited',
        columns: [
            {
                name: "id",
                hiddenField: true,
                defaultValue: () => fuelCard.id,
            },
            {
                label: "Card Number",
                name: "cardNumber",
                defaultValue: () => fuelCard.cardNumber,
                disabled: true,
            },
            {
                label: "Card Status",
                name: "status",
                defaultValue: () => fuelCard.status !== "ACTIVE" && fuelCard.status !== "INACTIVE" && fuelCard.status !== "HOLD" ? "FRAUD" : fuelCard.status,
                type: "select",
                dataset: (fuelCard.status === "ACTIVE" || fuelCard.status === "INACTIVE" || fuelCard.status === "HOLD") ? ["ACTIVE", "INACTIVE", "HOLD"] : ["FRAUD"],
                disableVal: "FRAUD",
            },
            {
                label: "Current Truck",
                name: "currentTruck",
                suggestionsEnabled : true,
                suggestionsLink : API_ROOT+'trucks/allTrucksBySimilarTruckNumber?pattern=',
                dataValueRequired : true,
                autoComplete : 'off',
                displayValueGenerator : (rawValue)=>{return `${rawValue['truckNumber']}`},
                defaultValue:()=>fuelCard['currentTruck']?`${fuelCard.currentTruck.truckNumber}`:'',
                predefinedDatValue:fuelCard['currentTruck'] ? JSON.stringify(fuelCard['currentTruck']) : null,
                rawValComparationFieldName : "truckNumber",
                afterMinimumChars: 2,
            },
            fuelCard.blocked ? null :{
                label: "Driver Id",
                name: "pin",
                defaultValue: () => fuelCard.pin,
                autoComplete:"off"
            },
            fuelCard.blocked ? null :{
                label: "Driver Name",
                name: "driverName",
                defaultValue: () => fuelCard.driverName,
                autoComplete:"off",
            }
        ]
    }
    
    
}